import React from "react";
import { Link } from "react-router-dom";

const RELATED_LINKS = [
  ["/services/kitchen-remodeling", "Kitchen Remodeling"],
  ["/services/bathroom-remodeling", "Bathroom Remodeling"],
  ["/services/roof-repair", "Roof Repair"],
  ["/services/roof-replacement", "Roof Replacement"],
  ["/services/outdoor-living", "Outdoor Living"],
  ["/services/home-additions", "Home Additions"],
  ["/services/handyman-punch-list", "Punch List"],
  ["/services/investor-property-repairs", "Investor Repairs"],
  ["/maintenance-plans", "Maintenance Plans"],
];

export default function CityQuickLinks({ cityName }) {
  return (
    <div className="bg-white p-6 rounded border border-gray-200">
      <div className="br-eyebrow text-br-bronze">Quick Links</div>
      <h3 className="font-display text-xl mt-2 tracking-widest uppercase">Related Services for {cityName} Homes</h3>
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-2 text-sm">
        {RELATED_LINKS.map(([to, label]) => (
          <Link key={to} to={to} className="px-3 py-2 rounded border border-gray-200 hover:border-br-bronze hover:text-br-bronze transition">{label}</Link>
        ))}
      </div>
    </div>
  );
}
